<script>
    import ColorPicker from "svelte-awesome-color-picker";
    import { createEventDispatcher } from "svelte";

    export let value;
    export let label;

    const dispatch = createEventDispatcher();

    $: hex = value;

    $: if (hex) {
        dispatch("change", hex);
    }
</script>

<div class="form-field-wrapper">
    <label style="font-weight: bold;">{label}</label>
    <ColorPicker bind:hex isAlpha={false} />
</div>
